import apiClient from "@/shared/api/apiClient";

export const getServiceCodesList = async (params) => {
  try {
    const { data } = await apiClient.get("/services/codes/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getServiceCodesList failed", e);
  }
};
